'use client';

import { ErrorScreen } from '@modules/shared/components/status-screens/error-screen/error-screen';

import * as React from 'react';

export interface NotFoundScreenProps {
  headline?: string | number;
  title?: React.ReactNode;
  children?: React.ReactNode;
}

type Props = Readonly<NotFoundScreenProps>;

const NotFoundScreen: React.FC<Props> = ({
  headline = '404',
  title = 'Not found?! Someone must have eaten that page.',
  children,
}) => (
  <ErrorScreen
    headline={headline}
    title={title}
  >
    {children}
  </ErrorScreen>
);

export { NotFoundScreen };
